import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  cookieDomain: '/api',
  apiUrl: '/api',
  socketUrl: 'ws://dealer.urbansofa.nl/ws',
  absolutePath: '/',
  locale: 'fa',
  maxStringLength: 250,
  maxIntegerLength: 22,
  minPassword: 8,
  emailPattern: '.+\\@.+\\..{2,}',
  userIdleTimeout: 30, // In minute
  adminDomain: '/',
  lunchDomain: 'http://teams.saku.bugloos.be',
  recaptchaSiteKey: '6Lftw3wtAAAAANz3E_YyOEgPTPyoqonrZzqzCyub',
  sentryDSN: 'https://ad9d671d312ca2220f27898c97fc525f@sentry.bugloos.com/10',
  sentryURL: 'https://sentry.bugloos.work/api',
  environment: 'production',
  release: '1.0.0',
  };
